export default __webpack_public_path__ + "static/media/logo_padrao_delta.9dfea290.png";